const state = {
    mLSearchObj: null,
    arrivalMultiCityLs:[],
    isMLSearch:null,
    isModifySearch:null
};

const getters = {
   
   
    GET_ML_ARR_LS: (state) => {
        return state.arrivalMultiCityLs;
    },
    GET_ML_SEARCH_OBJ: (state) => {
        return state.mLSearchObj;
    },
    GET_IS_ML_SEARCH: (state) => {
        return state.isMLSearch;
    },
    GET_IS_MODIFY_SEARCH: (state) => {
        return state.isModifySearch;
    },
};


const actions = {

    CLEAR_C_ML_SEARCH_STORE: ({ commit }) => {
        commit('clearCMlSearchStore');
    },
   
    SET_ML_ARR_LS: ({ commit }, arrLs) => {

        commit('saveMLArrList', arrLs);

    },
    SET_ML_SEARCH_OBJ: ({ commit }, search) => {

        commit('saveMlSearchObj', search);

    },
    SET_IS_ML_SEARCH: ({ commit }, isML) => {

        commit('saveIsMlSearch', isML);

    },
    SET_IS_MODIFY_SEARCH: ({ commit }, isModifySearch) => {

        commit('saveIsModifySearch', isModifySearch);

    },

};


const mutations = {
    clearCMlSearchStore: (state) => {
      
        state.arrivalMultiCityLs=[];
        state.mLSearchObj=null;
        state.isMLSearch=null;
        state.isModifySearch=null;

       
    },

  
    saveMLArrList: (state, arrLs) => {
        
        state.arrivalMultiCityLs=arrLs;
    },

    saveMlSearchObj: (state, search) => {
        
        state.mLSearchObj=search;
    },
    saveIsMlSearch: (state, isML) => {
        
        state.isMLSearch=isML;
    },
    saveIsModifySearch: (state, isModifySearch) => {
        
        state.isModifySearch=isModifySearch;
    },
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}